import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    uid: sessionStorage.getItem("uid") || "",
    token: sessionStorage.getItem("token") || "",
    nickName: sessionStorage.getItem("nickName") || "",
    isAdmin: sessionStorage.getItem("isAdmin") || "",
    collapseVal: sessionStorage.getItem("collapse") || "",
    source: "",
    permissions: "",
  },
  getters: {
    isCollapse(state) {
      return state.collapseVal === "1";
    }
  },
  mutations: {
    // 存储登录信息
    setLoginInfo(state, {uid,token,nickName,isAdmin}) {
      sessionStorage.setItem("uid", state.uid = uid);
      sessionStorage.setItem("token",  state.token = token);
      sessionStorage.setItem("nickName", state.nickName = nickName);
      sessionStorage.setItem("isAdmin", state.isAdmin = isAdmin);
    },
    // 存储取消请求
    setSource(state, val) {
      state.source = val;
    },
    // 存储权限
    setPermission(state, val) {
      state.permissions = val;
    },
    // 切换collapse
    switchCollapse(state) {
      let val = state.collapseVal ? "" : "1";
      state.collapseVal = val;
      sessionStorage.setItem("collapse", val);
    },
    // 清空数据
    clearData (state) {
      Object.keys(state).forEach(key => state[key] = "");
      state.collapseVal = document.body.clientWidth <= 1050 ? "1" : "";
    }
  },
  actions: {
  },
  modules: {
  }
})
